import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';
import useSWRMutation from 'swr/mutation';

export const getDeleteMembershipTypeCachedKey = () => ['/api/MembershipType'];

export const useDeleteMembershipType = () => {
  const { selectedOrganisationId, membershipTypeApi } = usePrivate();

  const path =
    selectedOrganisationId && membershipTypeApi
      ? getDeleteMembershipTypeCachedKey()
      : null;

  const { data, trigger, isMutating } = useSWRMutation(
    path,
    (key, { arg }: { arg: number[] }) =>
      membershipTypeApi?.apiMembershipTypeDelete(arg),
    {
      onError(error) {
        console.log(
          '[BREEDLOGIC] <useDeleteMembershipType> error from Membership Type deletion',
          error,
        );
      },
      onSuccess() {
        enqueueSnackbar('Membership Types removed', { variant: 'success' });
      },
    },
  );

  return {
    data,
    trigger,
    isLoading: isMutating,
  };
};
